import { render, staticRenderFns } from "./DoTaskForm.vue?vue&type=template&id=04b74350"
import script from "./DoTaskForm.vue?vue&type=script&lang=js"
export * from "./DoTaskForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports